import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
    },
    /** Applied to the SVG when no `className` is passed; override size via `className` + `fontSize`. */
    defaultGlyph: {
        fontSize: theme.typography.pxToRem(20),
    },
}));

/**
 * Font Awesome (SVG) icon wrapper aligned with Mobile ClientApp theme sizing.
 * Import icons by name for tree-shaking, e.g. `import { faPlus } from '@fortawesome/free-solid-svg-icons'`.
 *
 * @example
 * import { faPlus } from '@fortawesome/free-solid-svg-icons';
 * <FaIcon icon={faPlus} className={classes.someSlot} />
 */
const FaIcon = ({ icon, className, title, ariaHidden, ...rest }) => {
    const classes = useStyles();
    const glyphClassName = className || classes.defaultGlyph;
    return (
        <span className={classes.root} title={title}>
            <FontAwesomeIcon icon={icon} className={glyphClassName} aria-hidden={ariaHidden} {...rest} />
        </span>
    );
};

FaIcon.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    ariaHidden: PropTypes.bool,
};

FaIcon.defaultProps = {
    ariaHidden: true,
};

export default FaIcon;
